/* eslint-disable no-restricted-globals */
import {
  IonButton,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonImg,
  IonPage,
  IonRow,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import AngleImg from "../assets/images/angle.png";
import { useHistory } from "react-router-dom";
import {
  getAngleValues,
  unMuteAndIncreaseVolume,
} from "../utils/mobile-bridge";
import { ASSESSMENT_STATUSES } from "../movenet/params";

import { useRecoilState } from "recoil";
import {
  currentAssessmentState,
  defaultAssessment,
  networkConnectionStatus,
} from "../data/atoms";
import TopLeftUserName from "../components/TopLeftUserName";
import {
  setupVoiceListener,
  microphoneStatusListener,
} from "../services/VoiceCommandService";
interface Props {
  restartAdjustment?: any;
}

const AngleAdjustment: React.FC<Props> = ({ restartAdjustment }) => {
  const [currentAssessment, setcurrentAssessmentState] = useRecoilState(
    currentAssessmentState
  );

  const [sliderValue, setsliderValue] = useState(0);
  const [deviceAngleValue, setDeviceAngleValue] = useState(0);
  const [angleOk, setangleOk] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus
  );
  const [isVolumeOk, setIsVolumeOk] = useState(false);
  const [isAngleCorrect, setIsAngleCorrect] = useState(true);

  let history = useHistory();
  let location =
    window.location.href == window.location.origin + "/angle-adjustment"
      ? true
      : false;

  let Window = window as any;
  Window["AngleAdjustmentPageReference"] = {
    component: this,
    UpdateSliderOnMovement: UpdateSliderOnMovement,
  };

  Window["AssessmentInfoReference"] = {
    component: this,
    UpdateDeviceVolumeStatus: UpdateDeviceVolumeStatus,
    UpdateDeviceAngleStatus: UpdateDeviceAngleStatus,
  };

  function UpdateDeviceVolumeStatus(status: boolean) {
    setIsVolumeOk(status);
  }

  function UpdateDeviceAngleStatus(status: boolean) {
    setIsAngleCorrect(status);
  }

  useEffect(() => {
    console.log("location useEffect", location);
    console.log("process.env.NODE_ENV", process.env.NODE_ENV);

    // if (process.env.NODE_ENV === "development") {
    //   setIsDisabled(false);
    // }

    if (location) {
      getAngleValues(true);
    }
  }, [location]);

  useEffect(() => {
    setIsVolumeOk(unMuteAndIncreaseVolume());
  }, [location]);

  function UpdateSliderOnMovement(yaxis: number) {
    // console.log('yaxis val ', yaxis);

    yaxis = Number(yaxis);
    // yaxis = 90;
    if (yaxis >= 88 && yaxis <= 92) {
      setangleOk(true);
      setIsDisabled(false);
    } else {
      setangleOk(false);
      setIsDisabled(true);
    }
    setDeviceAngleValue(yaxis - 90);
    let calculateValue = ((yaxis * 2) / 360) * 100 - 2;
    // console.log("calculateValue", calculateValue)
    setsliderValue(calculateValue);
  }

  function getMedian(angleValue: number[]) {
    const mid = Math.floor(angleValue.length / 2);
    const nums = [...angleValue].sort((a, b) => a - b);
    return angleValue.length % 2 !== 0
      ? nums[mid]
      : (nums[mid - 1] + nums[mid]) / 2;
  }

  const goToAssessmentPage = () => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    setupVoiceListener();
    microphoneStatusListener();
    setupVoiceListener();
    microphoneStatusListener();
    setcurrentAssessmentState(defaultAssessment);
    //TODO: remove this when approach is modified
    localStorage.setItem("modalDisplayed", "0");
    getAngleValues(false);
    // //To hide the count modal
    const temp = document.getElementById("div-sts-rep-count");
    if (temp !== null) {
      temp.classList.add("d-none");
    }
    history.push("/assessment");
  };

  return (
    <IonPage placeholder={undefined}>
      <IonHeader
        placeholder={undefined}
        className="ion-no-border angle-adjustment-page-header"
      >
        <TopLeftUserName headerText="Assessment Type"></TopLeftUserName>
        <div
          className="info-icon"
          onClick={() => {
            if (!navigator.onLine) {
              setShowNetWorkRecoil({ isShown: true });
              return;
            }
            history.push("/phone-height-requirement");
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="34"
            height="34"
            viewBox="0 0 34 34"
            fill="none"
          >
            <g opacity="0.75">
              <circle
                cx="16.875"
                cy="16.875"
                r="15.2719"
                fill="white"
                stroke={isDisabled ? "#002E3C" : "#31344E"}
                stroke-width="3.20625"
              />
              <path
                d="M17.7306 21.1978H14.2826C14.2916 20.3865 14.3547 19.6879 14.4719 19.1019C14.5981 18.507 14.8099 17.9706 15.1074 17.4929C15.4139 17.0151 15.8195 16.5419 16.3243 16.0731C16.748 15.6945 17.1176 15.3339 17.4331 14.9914C17.7486 14.6489 17.9965 14.2973 18.1768 13.9367C18.3571 13.5671 18.4472 13.157 18.4472 12.7063C18.4472 12.1834 18.3661 11.7507 18.2038 11.4082C18.0506 11.0566 17.8162 10.7907 17.5007 10.6104C17.1942 10.4301 16.8066 10.34 16.3379 10.34C15.9502 10.34 15.5897 10.4256 15.2561 10.5969C14.9226 10.7592 14.6477 11.0116 14.4313 11.3541C14.224 11.6967 14.1158 12.1474 14.1068 12.7063H10.1856C10.2126 11.4713 10.4966 10.4527 11.0374 9.65041C11.5873 8.83912 12.322 8.23966 13.2414 7.85205C14.1609 7.45542 15.193 7.2571 16.3379 7.2571C17.5999 7.2571 18.6816 7.46443 19.583 7.87909C20.4845 8.28474 21.1741 8.88419 21.6518 9.67745C22.1296 10.4617 22.3685 11.4172 22.3685 12.544C22.3685 13.3283 22.2152 14.0269 21.9087 14.6398C21.6022 15.2438 21.2011 15.8072 20.7053 16.33C20.2095 16.8529 19.6642 17.3937 19.0692 17.9526C18.5554 18.4123 18.2038 18.8946 18.0145 19.3994C17.8342 19.9042 17.7396 20.5037 17.7306 21.1978ZM13.8769 25.3759C13.8769 24.799 14.0753 24.3212 14.4719 23.9426C14.8685 23.555 15.4004 23.3612 16.0674 23.3612C16.7255 23.3612 17.2528 23.555 17.6494 23.9426C18.0551 24.3212 18.2579 24.799 18.2579 25.3759C18.2579 25.9348 18.0551 26.4081 17.6494 26.7957C17.2528 27.1833 16.7255 27.3771 16.0674 27.3771C15.4004 27.3771 14.8685 27.1833 14.4719 26.7957C14.0753 26.4081 13.8769 25.9348 13.8769 25.3759Z"
                fill={isDisabled ? "#002E3C" : "#31344E"}
              />
            </g>
          </svg>
        </div>
      </IonHeader>

      <IonContent placeholder={undefined} className="slide-in-right">
        <IonGrid className="container" placeholder={undefined}>
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="phone-header-wraper-for-assessment-setup-pages angle-adjustment-page">
                <div className="top-inner-sec mt-assesment-page">
                  <h1>Angle Calibration</h1>
                  <p>Adjust the device’s angle.</p>
                  {ASSESSMENT_STATUSES.debug_calibration && (
                    <p>The current angle is {deviceAngleValue}</p>
                  )}
                </div>
              </div>
              <div className="angle-adjustment-wrap">
                <div className="range-slider-custom">
                  {/* ( angle-active )class add after range-slider-custom-inner-sec  */}

                  <div
                    className={`range-slider-custom-inner-sec ${
                      angleOk ? "angle-active" : ""
                    }`}
                  >
                    <span className="one"></span>
                    <span
                      className="two"
                      style={{ top: sliderValue + "%" }}
                    ></span>
                  </div>
                </div>
                {/* <div className="range-slider-custom angle-active">
                  <Slider
                    vertical={true}
                    buttons={true}
                    step={1}
                    value={sliderValue}
                    defaultValue={80}
                    min={1}
                    max={180}
                  ></Slider>
                  <span className="bar"></span>
                </div> */}
                <IonImg
                  src={AngleImg}
                  className="angle-img"
                  placeholder={undefined}
                ></IonImg>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
      <IonFooter className="ion-no-border" placeholder={undefined}>
        <IonGrid className="container" placeholder={undefined}>
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="phone-footer-wraper-for-assessment-setup-pages">
                <ul className="base-timeline">
                  <li className="base-timeline-item active"> </li>
                  <li className="base-timeline-item active"></li>
                  <li className="base-timeline-item active"></li>
                  <li className="base-timeline-item active"></li>
                </ul>
                <div className="btn-wrap-sec">
                  {
                    // angleOk && (
                    <IonButton
                      className="generic-btn"
                      disabled={isDisabled}
                      onClick={() => {
                        goToAssessmentPage();
                      }}
                      placeholder={undefined}
                    >
                      {" "}
                      {restartAdjustment?.restart
                        ? "Restart Assessment"
                        : "Complete"}
                    </IonButton>
                    // )
                  }
                </div>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonFooter>
    </IonPage>
  );
};
export default AngleAdjustment;
